import { ConflictValidation, ConflictValidators } from '../../utils/ConflictValidators'
import type { MappedScheduleItem } from './scheduleItemStore'

const getDriverNames = (items: MappedScheduleItem[]) => {
  if (items.length === 1) return items[0].driver_name
  const start = items.length === 2 ? items[0].driver_name : `${items[0].driver_name}, ${items[1].driver_name}`
  //formats end of string as "and {name}" or "and x more drivers"
  const end = ` and ${items.length > 3 ? `${items.length - 2} more drivers` : items.at(-1)?.driver_name}`
  return start + end
}

class UniqueTractor extends ConflictValidation<MappedScheduleItem> {
  constructor() {
    super('UniqueTractor')
  }
  validate = (itemA: MappedScheduleItem, itemB: MappedScheduleItem) =>
    !itemB.driver_or_carrier_id || !itemA.tractor_id || itemA.tractor_id !== itemB.tractor_id
  getErrorMessages = (items: MappedScheduleItem[]) =>
    `Tractor ${items[0].tractor_number} is in use by ${getDriverNames(items)}`
}

class UniqueTrailer extends ConflictValidation<MappedScheduleItem> {
  constructor() {
    super('UniqueTrailer')
  }
  validate = (itemA: MappedScheduleItem, itemB: MappedScheduleItem) =>
    !itemA.trailer_id || itemA.trailer_id !== itemB.trailer_id
  getErrorMessages = (items: MappedScheduleItem[]) =>
    `Trailer ${items[0].trailer_number} is in use by ${getDriverNames(items)}`
}

class UniqueDriver extends ConflictValidation<MappedScheduleItem> {
  constructor() {
    super('UniqueDriver')
  }
  validate = (itemA: MappedScheduleItem, itemB: MappedScheduleItem) =>
    !itemA.driver_or_carrier_id || itemA.driver_or_carrier_id !== itemB.driver_or_carrier_id
  getSingleErrorMessage = (item: MappedScheduleItem): string =>
    `${item.driver_name} already has a schedule at this time`
  getErrorMessages = (items: MappedScheduleItem[]) => `${items[0].driver_name} already has schedules at this time`
}

class InactiveTractor extends ConflictValidation<MappedScheduleItem> {
  constructor() {
    super('InactiveTractor')
  }
  validate = (itemA: MappedScheduleItem, itemB: MappedScheduleItem) =>
    !itemA.tractor_id || itemA.tractor_id !== itemB.tractor_id || itemB.shift !== 'inactive'
  getErrorMessages = (items: MappedScheduleItem[]) => `Tractor ${items[0].tractor_number} is inactive`
}
class OutOfServiceTractor extends ConflictValidation<MappedScheduleItem> {
  constructor() {
    super('OutOfServiceTractor')
  }
  validate = (itemA: MappedScheduleItem, itemB: MappedScheduleItem) =>
    !itemA.tractor_id || itemA.tractor_id !== itemB.tractor_id || itemB.shift !== 'oos'
  getErrorMessages = (items: MappedScheduleItem[]) => `Tractor ${items[0].tractor_number} is out of service`
}

export const conflictValidators = new ConflictValidators([
  new OutOfServiceTractor(),
  new InactiveTractor(),
  new UniqueTrailer(),
  new UniqueTractor(),
  new UniqueDriver(),
])
